import { useAccountStore } from '../store/store.account'
import { CartItem, PromoCode } from '../types/types.user'

export const usePromoDiscount = () => {
  const store = useAccountStore()

  const getCartPrice = (items: CartItem[]) => {
    return items.reduce((accum, cartItem) => {
      return (accum += cartItem.cost * cartItem.amount)
    }, 0)
  }

  const totalPrice = computed(() => {
    let sum = 0;
    let sale = 0;
    let delivery = 0;

    if (!store.isEstimateLoading) {
      sum = getCartPrice(store.cart || [])
    }

    if (store.estimate) {
      delivery = store.estimate.delivery_amount
    }


    if(store.promo && sum > store.promo.sale_amount) {
      sale = store.promo.sale_amount;
    }

    return {
      sum,
      delivery,
      sale
    }
  })

  return {
    totalPrice
  }
}
